import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {SubscriptionLike} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {TranslateService} from '@ngx-translate/core';
import {HelpersService} from '../../services/helpers.service';
import {Router} from '@angular/router';
import {DocumentsApiService} from '../../services/api/documents-api.service';
import {DocumentHelpersService} from '../../services/helpers/document-helpers.service';

@Component({
    selector: 'app-component-documents-search',
    templateUrl: './documents-search.component.html',
    styleUrls: ['./documents-search.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1})),
            transition(':enter', [style({opacity: 0}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0})))
        ])
    ]
})
export class DocumentsSearchComponent implements OnInit, OnDestroy {
    public formData;
    value: FormControl = new FormControl('');
    public settings = false;
    public getFormData = false;
    public searchHints = false;
    public searchHintsArr = [];
    public adaptiveOpen = false;
    public subscriptions: SubscriptionLike[] = [];
    public loading = false;
    @ViewChild('search') public search: ElementRef;
    @ViewChild('searchFilter') public searchFilter: ElementRef;
    private filter: any;

    constructor(
        protected translateService: TranslateService,
        protected documentApi: DocumentsApiService,
        protected router: Router,
        public helper: HelpersService,
        public documentHelper: DocumentHelpersService,
    ) {
    }

    @HostListener('document:click', ['$event'])
    afterClick(event: MouseEvent): void {
        this.searchHints = false;
        if (this.settings
            && this.searchFilter
            && !this.searchFilter.nativeElement.contains(event.target)
            && this.search
            && !this.search.nativeElement.contains(event.target)
        ) {
            this.settings = false;
        }
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.translateService.get('SEARCH').subscribe(data => {
                this.formData = [{
                    label: data.SEARCH,
                    type: 'select',
                    data: [
                        {
                            id: 0,
                            name: data.NOT_SELECTED
                        },
                        {
                            id: 'folder',
                            name: data.FOLDER
                        }, {
                            id: 'collection',
                            name: data.COLLECTION
                        }, {
                            id: 'file',
                            name: data.FILE
                        }
                    ],
                    formControlName: 'instance_type',
                    formState: 0
                }, {
                    label: data.STATUS,
                    type: 'select',
                    data: [{
                        id: 0,
                        name: data.NOT_SELECTED
                    }, {
                        id: 1,
                        name: data.SIGNED
                    }, {
                        id: 2,
                        name: data.NOT_SIGNED
                    }],
                    formControlName: 'status',
                    formState: 0
                }, {
                    label: data.LAST_CHANGE,
                    type: 'select',
                    data: [
                        {
                            id: 0,
                            name: data.NOT_SELECTED
                        },
                        {
                            id: 'day',
                            name: data.DAY
                        },
                        {
                            id: 'week',
                            name: data.WEEK
                        },
                        {
                            id: '30 days',
                            name: data.MONTH
                        },
                        {
                            id: 'year',
                            name: data.YEAR
                        },
                    ],
                    formControlName: 'change_period',
                    formState: 0
                }];
            })
        );
        this.subscriptions.push(this.value.valueChanges
            .subscribe(next => {
                this.settings = false;
                this.hideSidebar();
                if (next.length >= 2) {
                    this.searchHints = true;
                    this.getResult(next);
                } else {
                    this.searchHints = false;
                }
            }));

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(
            (subscription) => subscription.unsubscribe());
        this.subscriptions = [];
    }

    form(e): void {
        for (const item of this.formData) {
            item.formState = e[item.formControlName];
        }
        this.getFormData = false;
        this.filter = e;
    }

    hideSidebar(): void {
        const menu = document.getElementsByClassName('left_block');
        menu[0]?.classList.remove('open');
    }

    getResult(title = null): void {
        if (!title) {
            title = this.value.value;
        }
        this.loading = true;
        this.settings = false;
        const query = {
            title: null
        };
        if (this.filter && Object.keys(this.filter).length) {
            for (const key in this.filter) {
                if (this.filter[key]) {
                    query[key] = this.filter[key];
                }
            }
        }
        query.title = title;
        this.documentApi.search(query).subscribe({
            next: data => {
                this.searchHintsArr = data.results;
                this.searchHints = true;
                this.loading = false;
            }, error: () => {
                this.searchHintsArr = [];
                this.loading = false;
            }
        });
    }

    async redirect(item): Promise<any> {
        this.value.patchValue('');
        if (item.type === 'collection') {
            await this.router.navigate(['/account/doc/nav/collection/' + item.id]);
        } else if (item.type === 'folder') {
            await this.router.navigate(['/account/doc/nav/' + item.id]);
        } else if (item.type === 'file') {
            await this.router.navigate(['/account/doc/nav/file/' + item.key]);
        }
    }
}
